// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"dr-z","breadcrumbForward":"er-z","breadcrumbBack":"fr-z","selected":"gr-z"};